/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { createSimulatedInvoiceFromDiscriminatorValue, createValidationProblemDetailsFromDiscriminatorValue, serializeInvoiceCreateRequest, serializeSimulatedInvoice, type InvoiceCreateRequest, type SimulatedInvoice, type ValidationProblemDetails } from '../../models/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type Parsable, type ParsableFactory, type RequestConfiguration, type RequestInformation, type RequestsMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /Invoice/Simulate
 */
export interface SimulateRequestBuilder extends BaseRequestBuilder<SimulateRequestBuilder> {
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {Promise<SimulatedInvoice>}
     * @throws {ValidationProblemDetails} error when the service returns a 400 status code
     */
     post(body: InvoiceCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : Promise<SimulatedInvoice | undefined>;
    /**
     * @param body The request body
     * @param requestConfiguration Configuration for the request such as headers, query parameters, and middleware options.
     * @returns {RequestInformation}
     */
     toPostRequestInformation(body: InvoiceCreateRequest, requestConfiguration?: RequestConfiguration<object> | undefined) : RequestInformation;
}
/**
 * Uri template for the request builder.
 */
export const SimulateRequestBuilderUriTemplate = "{+baseurl}/Invoice/Simulate";
/**
 * Metadata for all the requests in the request builder.
 */
export const SimulateRequestBuilderRequestsMetadata: RequestsMetadata = {
    post: {
        uriTemplate: SimulateRequestBuilderUriTemplate,
        responseBodyContentType: "application/json",
        errorMappings: {
            400: createValidationProblemDetailsFromDiscriminatorValue as ParsableFactory<Parsable>,
        },
        adapterMethodName: "send",
        responseBodyFactory:  createSimulatedInvoiceFromDiscriminatorValue,
        requestBodyContentType: "application/json",
        requestBodySerializer: serializeInvoiceCreateRequest,
        requestInformationContentSetMethod: "setContentFromParsable",
    },
};
/* tslint:enable */
/* eslint-enable */
